import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=6c540dc2&scoped=true&"
import script from "./pageHeader.vue?vue&type=script&lang=js&"
export * from "./pageHeader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./pageHeader.vue?vue&type=style&index=0&id=6c540dc2&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6c540dc2",
  "6cf1ac0f"
  
)

component.options.__file = "pageHeader.vue"
export default component.exports